import type { LoadedSchema } from '@cli-types/core-engine/schema-reader.js'
import { toKebabCase } from '@cli-utils/text.js'

export function getGeneratedSchemaRoutePath(loaded: LoadedSchema, adminRoutePath: string): string {
  const schemaPath = toKebabCase(loaded.schema.name)
  return loaded.type === 'form'
    ? `${adminRoutePath}/forms/${schemaPath}`
    : `${adminRoutePath}/${schemaPath}`
}
